import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
const SelectedOption = (props) => {
    const { label, placeholder, selectedItem, options, showSelectedItemIcon, showUnselectedItemIcons } = props;
    const renderUnselectedItemIcons = (optionsToRender, currentSelectedItem) => {
        const optionSpans = optionsToRender
            .filter(option => !option.header)
            .map(option => (_jsx("span", Object.assign({ className: `margin-right-5 ${currentSelectedItem && currentSelectedItem.id === option.id ? '' : 'inactiveIcon'}` }, { children: option.icon }), option.id)));
        return _jsx("span", { children: optionSpans });
    };
    const getSelectedItemLabel = (item, placeholderValue) => {
        if (showUnselectedItemIcons) {
            return renderUnselectedItemIcons(options, item);
        }
        if (!item) {
            // render a placeholder or if there is none render a non-breaking space "&nbsp;"
            return placeholderValue ? _jsx("span", Object.assign({ className: 'placeholder' }, { children: placeholderValue })) : '\u00a0';
        }
        return (_jsxs("span", { children: [item.icon && _jsx("span", Object.assign({ className: 'margin-right-5' }, { children: item.icon })), !showSelectedItemIcon && item.label] }));
    };
    return (_jsxs("span", Object.assign({ className: 'selected-option-text' }, { children: [label && _jsxs("span", Object.assign({ className: 'selected-option-text-label' }, { children: [label, ":"] })), _jsx("span", { children: getSelectedItemLabel(selectedItem, placeholder) })] })));
};
export default SelectedOption;
